class ZoomGallery extends HTMLElement {
  constructor() {
    super();

    this.activeVideos = [];

    window.loadSwiper.then(({ Swiper, EffectFade, Thumbs }) => {
      this.Swiper = Swiper;
      this.EffectFade = EffectFade;
      this.Thumbs = Thumbs;

      this._initThumbsCarousel();
      this._initCarousel();
    });
  }

  _initThumbsCarousel() {
    const swiperParams = {
      modules: [this.Thumbs],
      slidesPerView: "auto",
      spaceBetween: 16,
      speed: 400,
      watchSlidesProgress: true,
      centerInsufficientSlides: true,
    };

    this.thumbsSwiper = new this.Swiper(
      this.querySelector(`.${this._prefix}__thumbnails-list-wrapper`),
      swiperParams,
    );
  }

  _initCarousel() {
    const swiperParams = {
      slidesPerView: "auto",
      initialSlide: this.dataset.preselectMediaIndex,
      speed: 400,
      watchSlidesProgress: true,
      zoom: {
        maxRatio: 2,
      },
      thumbs: {
        swiper: this.thumbsSwiper,
      },
      navigation: {
        nextEl: this.querySelector("[data-navigation-next]"),
        prevEl: this.querySelector("[data-navigation-previous]"),
      },
      init: false,
    };

    this.gallerySwiper = new this.Swiper(
      this.querySelector(`.${this._prefix}__media-container`),
      swiperParams,
    );

    const processVisibleSlides = () => {
      const visibleSlides = this.gallerySwiper.slides.filter((slide) =>
        slide.classList.contains("swiper-slide-visible"),
      );
      this._selectVideo(visibleSlides);
    };

    this.gallerySwiper.on("afterInit", processVisibleSlides);
    this.gallerySwiper.on("slideChange", processVisibleSlides);

    // Default toggles on double click so manually toggle on click
    this.gallerySwiper.on("click", () => {
      this.gallerySwiper.zoom.toggle();
    });

    this.gallerySwiper.init();
  }

  _selectVideo(els) {
    this.activeVideos.forEach((video) => video.pause());

    this.activeVideos = [];

    els.forEach((el) => {
      const video = el.querySelector("video");

      if (video) {
        this.activeVideos.push(video);
        video.play();
      }
    });
  }

  get _prefix() {
    return this.dataset.classPrefix;
  }
}

if (!customElements.get("zoom-gallery")) {
  customElements.define("zoom-gallery", ZoomGallery);
}
